module.exports = __webpack_public_path__ + "fonts/5BDBE559C80C7A809.eot";